import React, { useState } from 'react';
import { Icon } from '@iconify/react';
import { getImageUrl } from '../../helpers/utils';

function Announcement() {
    return (
        <div className="rtygia-page">
            <section className="award-about">
                <div className="container announcements-item">
                    <div className="row justify-content-center">

                        <div className="col-lg-8">
                            
                            <img src={getImageUrl('announcements/1.png')} className='announcements-header'/>

                            <div className="section-header text-center mt-5">
                                <h2 className="section-title">RTYGIA Call For Applications</h2>
                                <span className="section-label">2026 APPLICATION CYCLE</span>
                            </div>

                            <p className="section-description-alt mt-3">
                                Route Tracers Global Services Ltd, invites applications from eligible members of the Young Surveyors Network (YSN), Nigeria for the Route Tracers YSN Geospatial Innovation Award (RTYGIA).
                                <br /><br />
                                RTYGIA is a 5-year initiative (2026-2031) designed to identify, support, and scale innovative ideas developed by young surveyors in the fields of surveying, geospatial technology, remote sensing, and environmental management.
                            </p>

                            <p className="section-description-alt">

                                <h2 className="section-title-sub">Award Details</h2>
                                <ul>
                                    <li><b>Award Amount:</b> USD $1,000</li>
                                    <li><b>Number of Awardees:</b> One (1) per year</li>
                                    <li><b>Additional Support:</b> Technical mentorship and professional guidance through Route Tracers Global Services and partner organizations</li>
                                    <li><b>Application Opens:</b> January 5, 2026</li>
                                    <li><b>Application Deadline:</b> March 31st, 2026</li>
                                    <li><b>Award Period:</b> July - December, 2026 (implementation support)</li>
                                </ul>

                                <h2 className="section-title-sub mt-5">Who Should Apply?</h2>

                                Applications are open to:

                                <br /><br />

                                <ul>
                                    <li>Surveyors aged 35 years or below</li>
                                    <li>Registered members of the Young Surveyors Network (YSN), Nigeria. Open to all chapters.</li>
                                    <li>Individuals with an original idea, project, or innovation in:</li>
                                    <ul>
                                        <li>Surveying</li>
                                        <li>Geographic Information Systems (GIS)</li>
                                        <li>Remote sensing</li>
                                        <li>Environmental management</li>
                                    </ul>
                                </ul>

                                <h2 className="section-title-sub mt-5">What We Are Looking For</h2>

                                All stages of Idea (Concept, Early prototype, Pilot stage, or Ready for scale) are welcome. However, your idea must not be previously funded by Route Tracers or other organization/institution.
                                <br /><br />

                                Proposals should demonstrate:

                                <ul>
                                    <li>Innovation and originality</li>
                                    <li>Practical relevance to the surveying or geospatial profession</li>
                                    <li>Potential for scalability or broader application</li>
                                    <li>Clear environmental, professional, or societal impact</li>
                                </ul>

                                <h2 className="section-title-sub mt-5">Application Timeline</h2>

                                <table className='timeline-table'>
                                    <thead>
                                        <th>Stage</th>
                                        <th>Period</th>
                                        <th>Description</th>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td>Call for Proposals</td>
                                            <td>January - March</td>
                                            <td>Applications open to eligible YSN members</td>
                                        </tr>
                                        <tr>
                                            <td>Submission Review</td>
                                            <td>April</td>
                                            <td>Independent judges conduct blinded reviews</td>
                                        </tr>
                                        <tr>
                                            <td>Selection</td>
                                            <td>May</td>
                                            <td>YSN Exco selects one awardee from top recommendations</td>
                                        </tr>
                                        <tr>
                                            <td>Announcement</td>
                                            <td>June</td>
                                            <td>Winner announced via YSN channels</td>
                                        </tr>
                                        <tr>
                                            <td>Implementation & Support</td>
                                            <td>July - December</td>
                                            <td>Awardee receives funding and mentorship</td>
                                        </tr>
                                        <tr>
                                            <td>YSN Conference Presentation</td>
                                            <td>November</td>
                                            <td>Awardee presents progress at annual YSN conference</td>
                                        </tr>
                                    </tbody>
                                </table>


                                <h2 className="section-title-sub mt-5">Selection Process</h2>

                                <ul>
                                    <li>All applications are reviewed independently by technical experts.</li>
                                    <li>Reviews are conducted blindly (no identifying information shared with judges).</li>
                                    <li>Final selection is made by the YSN Executive Committee, based on judges' recommendations.</li>
                                    <li>The sponsor is not involved in judging or selection.</li>
                                </ul>

                                <h2 className="section-title-sub mt-5">Governance</h2>

                                The award is hosted under HSCF's Social Change Portfolio, ensuring:

                                <ul>
                                    <li>Transparent administration</li>
                                    <li>Ethical oversight</li>
                                    <li>Clear reporting and accountability</li>
                                </ul>
                                <br />

                                <span className="section-label me-2">SPONSOR</span> Route Tracers Global Services Ltd.
                                <br />
                                <span className="section-label me-2">HOST</span> Health and Social Change Foundation (HSCF)
                                <br />
                                <span className="section-label me-2">BENEFICIARY PARTNER</span> Young Surveyors Network (YSN)
                                <br />


                                <button className="btn btn-donate mt-5" onClick={() => open('https://hscfoundation.limesurvey.net/rtygia?lang=en&newtest=Y')}>
                                    <Icon icon="mdi:form" className="me-1" />
                                    Apply Now
                                </button>

                            </p>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
}

export default Announcement;